export enum SidebarTab {
  PARCEL = "parcel",
  RESULT = "result",
}
export interface SidebarState {
  tab: SidebarTab;
  open: boolean;
}
